import Vue from 'vue'
import App from './App.vue'
import config from './config/'
import router from './router/'
import Api from './api/'
import store from './store/'
import Document from './document/'
import Util from './util/'
import moment from 'moment'
import echarts from 'echarts'
import './static/stylesheet/font.css'
import 'element-ui/lib/theme-chalk/index.css';
import '@/components/'
import element from 'element-ui'

window.Vue = Vue

async function init(Vue) {
    Vue.config.productionTip = false
    Vue.use(Api)
    Vue.use(config)
    Vue.use(Document)
    Vue.use(element)
    Vue.prototype.$Util = Util
    Vue.prototype.$Moment = moment
    Vue.prototype.$echarts = echarts
    Vue.prototype.$myRouter = router

    return new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
}

init(Vue)
